import React from 'react';

import { Box, InputAdornment, Stack, TextField, Typography } from '@mui/material';

import styled from '@emotion/styled';

import { OfferRequirements } from '../../../../graphql/API';
import { RadioContentBuy } from '../../../../pages/CreateUpdateOffer/components/formiks/OfferRequirement/RadioContentBuy';
import { OFFER_REQUIREMENTS_V2 } from '../../../../pages/CreateUpdateProducts/constants';
import Icons from '../../../../themes/icons';
import Button from '../../../Button/Button';
import { requirements } from '../../../Dialogs/CreateInvite/components/Step3';
import { useCreateInvite } from '../../../Dialogs/CreateInvite/context/CreateInvite.context';
import { HtmlTooltip } from '../../../HtmlTooltip/HtmlTooltip';
import SvgIcon, { IconName } from '../../../Icons';
import { OfferRequirementsV2 } from '../../../V2/OfferRequirements/OfferRequirementsV2';

export const RequirementStep: React.FC = () => {
  const { state, dispatch } = useCreateInvite();

  const handleOfferRequirementChange = (value: string) => {
    dispatch({
      type: 'update',
      payload: { requirements: value ?? undefined },
    });
  };

  const handlePreviousStep = () => {
    dispatch({
      type: 'prev',
      payload: { requirements: undefined },
    });
  };

  const handleTagChange = (value: string) => {
    dispatch({
      type: 'update',
      payload: { tag: value ?? undefined },
    });
  };

  return (
    <Box>
      <Box
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{ borderBottom: '1px solid #F1F2F1', backgroundColor: '#FCFCFC', px: 5, py: 3 }}
      >
        <Box display={'flex'} alignItems={'center'} gap={1.5}>
          <Button
            startIcon={<Icons.BackIcon />}
            onClick={() => {
              handlePreviousStep();
            }}
          />
          <Typography fontWeight={'500'} sx={{ fontFamily: 'Poppins', fontSize: '18px' }}>
            Select Requirement
          </Typography>
        </Box>
      </Box>
      <Stack spacing={4} p={5}>
        <Box display={'flex'} flexDirection={'column'} gap={5} alignItems={'flex-start'}>
          <Box display={'flex'} flexDirection={'column'} gap={1.5} minWidth={550} maxWidth={770}>
            {OFFER_REQUIREMENTS_V2.map((requirement) => (
              <OfferRequirementsV2
                key={requirement.id}
                active={requirement.value.includes(state.requirements as never)}
                {...requirement}
                handleChange={() => {
                  handleOfferRequirementChange(requirement.value[0]);
                }}
              />
            ))}
          </Box>

          {[
            OfferRequirements.postOnInstagramStories,
            OfferRequirements.postOnInstagramStories3x,
            OfferRequirements.postOnInstagramFeed,
            OfferRequirements.postOnInstagramReels,
          ].includes(state.requirements as OfferRequirements) && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <Box display={'flex'} alignItems={'center'} gap={2}>
                {requirements.map((requirement) => {
                  return (
                    <Box minWidth={'175px'}>
                      <RadioContentBuy
                        checked={state.requirements === requirement.value}
                        label={requirement.name}
                        icon={<SvgIcon name={requirement.iconName as IconName} />}
                        checkedIcon={<SvgIcon name={requirement.checkedIconName as IconName} />}
                        onClick={() => {
                          dispatch({
                            type: 'update',
                            payload: { requirements: requirement.value ?? undefined },
                          });
                        }}
                      />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}

          {state.requirements?.includes(OfferRequirements.postOnTikTokVideo) ? (
            <CustomBox>
              <Box display={'flex'} alignItems={'center'} gap={'8px'} mb={'15px'}>
                <Typography
                  sx={{
                    fontSize: '15px',
                    fontWeight: 500,
                  }}
                >
                  Tag (optional)
                </Typography>
                <HtmlTooltip
                  arrow
                  placement='top'
                  title={
                    <React.Fragment>
                      <Typography fontSize={'13px'} p={'12px'}>
                        Add your @TikTok handle to be tagged in posts
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <Icons.InfoIcon />
                </HtmlTooltip>
              </Box>
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position='start'>@</InputAdornment>,
                }}
                placeholder='tag'
                sx={{ minWidth: '342px' }}
                value={state.tag}
                onChange={(event) => handleTagChange(event.target.value)}
              />
            </CustomBox>
          ) : null}
        </Box>
      </Stack>
    </Box>
  );
};

const CustomBox = styled.div`
  display: flex;
  flex-direction: column;
  fieldset {
    border: 1px solid #e6e6e6;
  }
`;
